import React from 'react';

/** Breakdown-row colours: base and bonus green, skill credit blue, penalties red. */
export type FxTone = 'base' | 'credit' | 'bonus' | 'pen' | 'type' | 'rel' | 'overall';

/** Formula tokens: K = fixed rule constant, V = value from this prompt, O = operator, R = result. */
export const K: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="fx-k">{children}</span>
);
export const V: React.FC<{ children: React.ReactNode; tone?: FxTone }> = ({ children, tone }) => (
  <span className={tone ? `fx-v fx-v--${tone}` : 'fx-v'}>{children}</span>
);
export const O: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="fx-o">{children}</span>
);
export const R: React.FC<{ children: React.ReactNode; tone?: FxTone }> = ({ children, tone }) => (
  <span className={tone ? `fx-r fx-r--${tone}` : 'fx-r'}>{children}</span>
);

/** Parenthesised group. The parentheses stay neutral; the terms inside keep their colours. */
export const Group: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span className="fx-group">({children})</span>
);

export const Fx: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <code className="formula-chip">{children}</code>
);

export const FormulaLegend: React.FC = () => (
  <p className="fx-legend" aria-label="Formula colour key">
    <span className="fx-k">Fixed rule</span>
    <span className="fx-v">Your value</span>
    <span className="fx-r">Result</span>
  </p>
);
